/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Inactive/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Inactive({
  children,
  viewPath = "/DesignSystem/LedgerPaymentAccount/PersonPaymentAccount/Payor/Person/Content/Content/PracticeHub/Inactive"
  
}) {
let personPublicUserAccountEmailValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'public_user.account.email',
})
let constantData = '(needs to verify a/c)'
let aggregateData = fromAggregate.join(personPublicUserAccountEmailValueData, constantData)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="person.public_user.account.email"
 data="'(needs to verify a/c)'"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}